import { Navigate, Route, Routes } from 'react-router-dom'
import { getSettingsSections } from '@/constants/settings-nav'
import { SettingsAccountPage } from '@/components/settings/settings-account-page'
import { SettingsBillingRedirect } from '@/components/settings/settings-billing-redirect'
import { SettingsNotificationsPage } from '@/components/settings/settings-notifications-page'
import { SettingsPlaceholderPage } from '@/components/settings/settings-placeholder-page'

export function SettingsRoutes() {
  const sections = getSettingsSections()

  return (
    <Routes>
      <Route index element={<Navigate to="account" replace />} />
      <Route path="account" element={<SettingsAccountPage />} />
      <Route path="billing" element={<SettingsBillingRedirect />} />
      <Route path="profile" element={<Navigate to="account" replace />} />
      {sections.some((section) => section.kind === 'notifications') && (
        <Route path="notifications" element={<SettingsNotificationsPage />} />
      )}
      {sections
        .filter((section) => section.kind === 'placeholder')
        .map((section) => (
          <Route
            key={section.segment}
            path={section.segment}
            element={
              <SettingsPlaceholderPage
                title={section.label}
                description={section.description}
              />
            }
          />
        ))}
      <Route path="*" element={<Navigate to="account" replace />} />
    </Routes>
  )
}
